import { useProfile } from "../../components/portfolio/context/ProfileContext"

function Experience() {
   const {expDetails} = useProfile();   

   return (
      <>
         <section id="experience-section">
            <div className="exp-title">
               <h1> Work Experience </h1>
               <h5>My associations so far</h5>
            </div>
            <ul className="experience-list">
               {expDetails.map((details) => {
                  return (
                     <li className="info" key={details.id || details.title}>
                        <div className="work-year">
                           <img
                              src={details.src}
                              loading="lazy"
                              alt={details.title}
                           />
                        </div>
                        {/* <div class="cone" /> */}
                        <div className="work-description">
                           <h1>{details.title}</h1>
                           <h5>{details.subtitle}</h5>
                           <small>{details.year}</small>
                           <ul>
                              {details.listItems.map((item, i) => {
                                 return <li key={i}>{item}</li>;
                              })}
                           </ul>
                        </div>
                     </li>
                  );
               })}
            </ul>
         </section>
      </>
   );
}
export default Experience;
